<div class="add-pickup-wrapper">
  <form (ngSubmit)="onSubmit()" [formGroup]="pickupForm">
    <app-modal-frame
      [headerText]="CONSTS.NEW_PICKUP_HEADER"
      (emitExit)="clickExit()"
    >
      <div class="content">
        <!-- Scheduling -->
        <ion-row class="scheduling">
          <ion-col size="12">
            <ion-row>
              <ion-col size="12" class="section-header">
                {{ CONSTS.SCHEDULING_SUBHEADER }}
              </ion-col>
            </ion-row>

            <ion-row>
              <!-- OnDemand Pickup -->
              <ion-col size="3" class="checkbox-container-col">
                <app-form-checkbox
                  [label]="CONSTS.ON_DEMAND_PICKUP"
                  formControlName="ondemandPickUp"
                ></app-form-checkbox>
              </ion-col>

              <!-- Availability -->
              <ion-col size="9" class="days-assigned-wrapper">
                <div
                  [ngClass]="{
                    disabled: isOnDemandPickup,
                  }"
                >
                  {{ CONSTS.DATE_ASSIGNED }}
                  @if (!isOnDemandPickup) {
                    <span class="required-field"> * </span>
                  }
                </div>
                <app-days-assigned
                  [data]="pickupForm.get(PICKUPS.DAYS_ASSIGNED)?.value"
                  [disabled]="isOnDemandPickup"
                  (updateAvailabilityEvent)="daysAssignedUpdated($event)"
                ></app-days-assigned>
              </ion-col>
            </ion-row>
          </ion-col>

          <ion-col size="12">
            <ion-row>
              <!-- Pickup Request Number -->
              <ion-col size="3">
                <div class="form-group">
                  <label [for]="CONTROLS.PICKUP_REQUEST_NUMBER">
                    {{ CONSTS.PICKUP_REQUEST_NUMBER }}
                  </label>
                  <ion-input
                    class="form-control"
                    type="text"
                    maxlength="11"
                    [formControlName]="CONTROLS.PICKUP_REQUEST_NUMBER"
                    [ngClass]="!isOnDemandPickup ? 'disabled-input' : ''"
                  ></ion-input>
                </div>
              </ion-col>

              <!-- Pickup Point -->
              <ion-col size="3">
                <div class="form-group">
                  <label [for]="CONTROLS.PICKUP_POINT">
                    {{ CONSTS.PICKUP_POINT }}
                  </label>
                  <ion-input
                    class="form-control"
                    type="text"
                    maxlength="11"
                    [formControlName]="CONTROLS.PICKUP_POINT"
                  ></ion-input>
                </div>
              </ion-col>

              <!-- Route-->
              <ion-col size="3">
                <div class="form-grou select-form-group">
                  <label [for]="CONTROLS.ROUTE">{{ CONSTS.ROUTE }}</label>
                  <ng-select
                    appearance="outline"
                    class="custom-select"
                    labelForId="route"
                    [searchable]="false"
                    [clearable]="false"
                    [items]="routes()"
                    [formControlName]="CONTROLS.ROUTE"
                  >
                  </ng-select>
                </div>
              </ion-col>
            </ion-row>
          </ion-col>

          <ion-col size="12">
            <ion-row>
              <!-- Start Date -->
              <ion-col size="3">
                <div class="form-group">
                  <label [for]="CONTROLS.START_DATE"
                    >{{ CONSTS.START_DATE }}
                  </label>
                  <app-form-date-picker
                    [placeholder]="CONSTS.DATE_PLACEHOLDER"
                    [formControlName]="CONTROLS.START_DATE"
                    [minDate]="minDate"
                    [maxDate]="isOnDemandPickup ? maxDate : scheduledMaxDate"
                  ></app-form-date-picker>
                </div>
              </ion-col>

              <!-- End Date -->
              <ion-col size="3">
                <div class="form-group">
                  <label [for]="CONTROLS.END_DATE"
                    >{{ CONSTS.END_DATE }}
                  </label>
                  @if (isOnDemandPickup) {
                    <app-form-date-picker
                      [placeholder]="CONSTS.DATE_PLACEHOLDER"
                      [minDate]="minDate"
                      [maxDate]="scheduledMaxEndDate"
                      [disabled]="isOnDemandPickup"
                    ></app-form-date-picker>
                  }
                  @if (!isOnDemandPickup) {
                    <app-form-date-picker
                      [formControlName]="CONTROLS.END_DATE"
                      [minDate]="minDate"
                      [maxDate]="scheduledMaxEndDate"
                    ></app-form-date-picker>
                  }
                </div>
              </ion-col>

              <!-- Ready Time-->
              <ion-col size="2">
                <div class="form-group">
                  <app-form-time-picker
                    [defaultStartTime]="defaultStartTime"
                    [placeholderText]="CONSTS.TIME_PLACEHOLDER"
                    [form]="pickupForm"
                    [altIconSpacing]="true"
                    [headerText]="CONSTS.READY_TIME"
                    [control]="CONTROLS.READY_TIME"
                    [required]="false"
                  ></app-form-time-picker>
                </div>
              </ion-col>

              <!-- Commit Time-->
              <ion-col size="2">
                <div class="form-group">
                  <app-form-time-picker
                    [defaultStartTime]="defaultStartTime"
                    [placeholderText]="CONSTS.TIME_PLACEHOLDER"
                    [form]="pickupForm"
                    [altIconSpacing]="true"
                    [control]="CONTROLS.COMMIT_TIME"
                    [required]="false"
                    [headerText]="CONSTS.COMMIT_TIME"
                  ></app-form-time-picker>
                </div>
              </ion-col>

              <!-- Closing Time-->
              <ion-col size="2">
                <div class="form-group">
                  <app-form-time-picker
                    [defaultStartTime]="defaultStartTime"
                    [placeholderText]="CONSTS.TIME_PLACEHOLDER"
                    [form]="pickupForm"
                    [altIconSpacing]="true"
                    [control]="CONTROLS.CLOSING_TIME"
                    [required]="false"
                    [headerText]="CONSTS.CLOSING_TIME"
                  ></app-form-time-picker>
                </div>
              </ion-col>
            </ion-row>
          </ion-col>

          <ion-col size="12">
            <ion-row>
              <!-- Interrupt Date -->
              <ion-col size="3">
                <div class="form-group">
                  <label [for]="CONTROLS.INTERRUPT_DATE"
                    >{{ CONSTS.INTERRUPT_DATE }}
                  </label>
                  <app-form-date-picker
                    [placeholder]="CONSTS.DATE_PLACEHOLDER"
                    [formControlName]="CONTROLS.INTERRUPT_DATE"
                    [minDate]="minDate"
                    [maxDate]="isOnDemandPickup ? maxDate : scheduledMaxDate"
                  ></app-form-date-picker>
                </div>
              </ion-col>

              <!-- Restart Date -->
              <ion-col size="3">
                <div class="form-group">
                  <label [for]="CONTROLS.RESTART_DATE"
                    >{{ CONSTS.RESTART_DATE }}
                  </label>
                  <app-form-date-picker
                    [placeholder]="CONSTS.DATE_PLACEHOLDER"
                    [formControlName]="CONTROLS.RESTART_DATE"
                    [minDate]="minDate"
                    [maxDate]="isOnDemandPickup ? maxDate : scheduledMaxDate"
                  ></app-form-date-picker>
                </div>
              </ion-col>
            </ion-row>
          </ion-col>
        </ion-row>

        <hr />

        <!-- Customer Information -->
        <ion-row class="customer-information">
          <ion-col size="12">
            <ion-row>
              <ion-col size="12" class="section-header">
                {{ CONSTS.CUSTOMER_SUBHEADER }}
              </ion-col>
            </ion-row>

            <ion-row>
              <!-- Shipper Number -->
              <ion-col size="1.5">
                <div class="form-group">
                  <app-form-text-field
                    [labelText]="CONSTS.SHIPPER_NUMBER"
                    [form]="pickupForm"
                    [control]="CONTROLS.SHIPPER_NUMBER"
                    [regexType]="SpecialCharacters.NO_SPACE"
                    [maxLength]="6"
                    [minLength]="6"
                    [biggerText]="true"
                  ></app-form-text-field>
                </div>
              </ion-col>

              <!-- Customer Name -->
              <ion-col size="3.5">
                <div class="form-group">
                  <app-form-text-field
                    [labelText]="CONSTS.CUSTOMER_NAME"
                    [form]="pickupForm"
                    [control]="CONTROLS.CUSTOMER_NAME"
                    [regexType]="SpecialCharacters.PICKUP_POPUP"
                    [maxLength]="25"
                    [biggerText]="true"
                    [autoCapitalizeCharacters]="true"
                    (paste)="commonUtils.sanitizePaste($event, 'pickupPopup')"
                  ></app-form-text-field>
                </div>
              </ion-col>

              <!-- Contact Name -->
              <ion-col size="3.5">
                <div class="form-group">
                  <app-form-text-field
                    [labelText]="CONSTS.CONTACT_NAME"
                    [form]="pickupForm"
                    [control]="CONTROLS.CONTACT_NAME"
                    [hasRequiredSign]="false"
                    [maxLength]="22"
                    [biggerText]="true"
                    [autoCapitalizeCharacters]="true"
                  ></app-form-text-field>
                </div>
              </ion-col>

              <!-- Contact Number -->
              <ion-col size="3.5">
                <div class="form-group">
                  <app-form-text-field
                    [labelText]="CONSTS.CONTACT_NUMBER"
                    [form]="pickupForm"
                    [control]="CONTROLS.CONTACT_NUMBER"
                    [hasRequiredSign]="false"
                    [maxLength]="25"
                    [biggerText]="true"
                    [autoCapitalizeCharacters]="true"
                  ></app-form-text-field>
                </div>
              </ion-col>
            </ion-row>

            <ion-row>
              <!-- Street Address -->
              <ion-col size="2">
                <div class="form-group">
                  <app-form-text-field
                    [labelText]="CONSTS.STREET_ADDRESS"
                    [form]="pickupForm"
                    [control]="CONTROLS.STREET_ADDRESS"
                    [regexType]="SpecialCharacters.PICKUP_ADDRESS"
                    [hasRequiredSign]="false"
                    [maxLength]="8"
                    [biggerText]="true"
                    [autoCapitalizeCharacters]="true"
                    (paste)="commonUtils.sanitizePaste($event, 'pickupAddress')"
                  ></app-form-text-field>
                </div>
              </ion-col>

              <!-- Prefix -->
              <ion-col size="1.5">
                <div class="form-group">
                  <app-form-text-field
                    [labelText]="CONSTS.PREFIX"
                    [form]="pickupForm"
                    [control]="CONTROLS.PREFIX"
                    [hasRequiredSign]="false"
                    [maxLength]="2"
                    [biggerText]="true"
                    [autoCapitalizeCharacters]="true"
                  ></app-form-text-field>
                </div>
              </ion-col>

              <!-- Street Name -->
              <ion-col size="3.5">
                <div class="form-group">
                  <app-form-text-field
                    [labelText]="CONSTS.STREET_NAME"
                    [form]="pickupForm"
                    [control]="CONTROLS.STREET_NAME"
                    [regexType]="SpecialCharacters.PICKUP_POPUP"
                    [maxLength]="30"
                    [biggerText]="true"
                    [autoCapitalizeCharacters]="true"
                    (paste)="commonUtils.sanitizePaste($event, 'pickupPopup')"
                  ></app-form-text-field>
                </div>
              </ion-col>

              <!-- Suffix -->
              <ion-col size="1.5">
                <div class="form-group">
                  <app-form-text-field
                    [labelText]="CONSTS.SUFFIX"
                    [form]="pickupForm"
                    [control]="CONTROLS.SUFFIX"
                    [hasRequiredSign]="false"
                    [maxLength]="2"
                    [biggerText]="true"
                    [autoCapitalizeCharacters]="true"
                  ></app-form-text-field>
                </div>
              </ion-col>

              <!-- Suite -->
              <ion-col size="1.5">
                <div class="form-group">
                  <app-form-text-field
                    [labelText]="CONSTS.SUITE"
                    [form]="pickupForm"
                    [control]="CONTROLS.SUITE"
                    [regexType]="SpecialCharacters.PICKUP_POPUP"
                    [hasRequiredSign]="false"
                    [maxLength]="8"
                    [biggerText]="true"
                    [autoCapitalizeCharacters]="true"
                    (paste)="commonUtils.sanitizePaste($event, 'pickupPopup')"
                  ></app-form-text-field>
                </div>
              </ion-col>

              <!-- Floor -->
              <ion-col size="2">
                <div class="form-group">
                  <app-form-text-field
                    [labelText]="CONSTS.FLOOR"
                    [form]="pickupForm"
                    [control]="CONTROLS.FLOOR"
                    [hasRequiredSign]="false"
                    [maxLength]="3"
                    [biggerText]="true"
                    [autoCapitalizeCharacters]="true"
                  ></app-form-text-field>
                </div>
              </ion-col>
            </ion-row>

            <ion-row>
              <!-- City -->
              <ion-col size="3">
                <div class="form-group">
                  <app-form-text-field
                    [labelText]="CONSTS.CITY"
                    [form]="pickupForm"
                    [control]="CONTROLS.CITY"
                    [regexType]="SpecialCharacters.PICKUP_POPUP"
                    [hasRequiredSign]="false"
                    [maxLength]="50"
                    [biggerText]="true"
                    [autoCapitalizeCharacters]="true"
                    (paste)="commonUtils.sanitizePaste($event, 'pickupPopup')"
                  ></app-form-text-field>
                </div>
              </ion-col>

              <!-- Province -->
              <ion-col size="1.5">
                <div class="form-group">
                  <app-form-text-field
                    [labelText]="CONSTS.PROVINCE"
                    [form]="pickupForm"
                    [control]="CONTROLS.PROVINCE"
                    [regexType]="SpecialCharacters.ALPHABET_ONLY"
                    [maxLength]="2"
                    [minLength]="2"
                    [biggerText]="true"
                    [autoCapitalizeCharacters]="true"
                    (paste)="commonUtils.sanitizePaste($event, 'alphabet')"
                  ></app-form-text-field>
                </div>
              </ion-col>

              <!-- Postal Code -->
              <ion-col size="2.5">
                <div class="form-group">
                  <app-form-text-field
                    [labelText]="CONSTS.POSTAL_CODE"
                    [maxLength]="8"
                    [form]="pickupForm"
                    [control]="CONTROLS.POSTAL_CODE"
                    [regexType]="SpecialCharacters.ALPHABET_NUMBER_NO_SPACE"
                    [biggerText]="true"
                    [autoCapitalizeCharacters]="true"
                    (paste)="commonUtils.sanitizePaste($event, 'alphanumeric')"
                  ></app-form-text-field>
                </div>
                @if (
                  pickupForm.get("postalCode")?.dirty &&
                  pickupForm.get("postalCode")?.errors?.["nonCanadianPostal"]
                ) {
                  <div class="required-field">
                    {{ CONSTS.CANADIAN_POSTAL_ERROR }}
                  </div>
                }
              </ion-col>

              <!-- Latitude -->
              <ion-col size="2.5">
                <div class="form-group">
                  <app-form-text-field
                    [labelText]="CONSTS.LATITUDE"
                    [form]="pickupForm"
                    [control]="CONTROLS.LATITUDE"
                    [hasRequiredSign]="false"
                    [readonly]="true"
                    [biggerText]="true"
                    [autoCapitalizeCharacters]="true"
                  ></app-form-text-field>
                </div>
              </ion-col>

              <!-- Longitude -->
              <ion-col size="2.5">
                <app-form-text-field
                  [labelText]="CONSTS.LONGITUDE"
                  [form]="pickupForm"
                  [control]="CONTROLS.LONGITUDE"
                  [hasRequiredSign]="false"
                  [readonly]="true"
                  [biggerText]="true"
                  [autoCapitalizeCharacters]="true"
                ></app-form-text-field>
              </ion-col>
            </ion-row>
          </ion-col>
        </ion-row>

        <hr />

        <!-- Notes -->
        <ion-row class="notes">
          <ion-col size="12">
            <ion-row>
              <ion-col size="12" class="section-header">
                {{ CONSTS.NOTES }}
              </ion-col>
            </ion-row>

            <ion-row class="notes-section">
              <!-- SSC Description -->
              <ion-col size="5">
                <div class="form-group">
                  <label [for]="CONTROLS.SSC_DESCRIPTION">
                    {{ CONSTS.SSC_DESCRIPTION }}
                  </label>
                  <textarea
                    rows="4"
                    class="form-control ssc-description"
                    type="text"
                    [formControlName]="CONTROLS.SSC_DESCRIPTION"
                  ></textarea>
                </div>
              </ion-col>

              <!-- Additional Information  -->
              <ion-col size="7">
                <div class="form-group">
                  <label [for]="CONTROLS.ADDITIONAL_INFORMATION">
                    {{ CONSTS.ADDITIONAL_INFORMATION }}
                  </label>
                  <textarea
                    rows="4"
                    class="form-control"
                    type="text"
                    [placeholder]="CONSTS.ADDITIONAL_INFORMATION_PLACEHOLDER"
                    [formControlName]="CONTROLS.ADDITIONAL_INFORMATION"
                  ></textarea>
                </div>
              </ion-col>
            </ion-row>
          </ion-col>
        </ion-row>
      </div>

      <div class="footer">
        <!-- Validate Button -->
        @if (isIDO()) {
          <div class="validation-section">
            <ion-row class="validate-row">
              <div class="validation-text">
                <ion-col>
                  @if (validationCode === "-5") {
                    <span class="validate-error-text">{{
                      CONSTS.VALIDATION_FAILED_NULL_SITE_ID
                    }}</span>
                  }
                  @if (validationCode === "-4") {
                    <span class="validate-error-text">{{
                      CONSTS.VALIDATION_FAILED_REQUEST_ID
                    }}</span>
                  }
                  @if (validationCode === "-3") {
                    <span class="validate-error-text">{{
                      CONSTS.VALIDATION_FAILED_INPUT_ADDRESS
                    }}</span>
                  }
                  @if (validationCode === "-2") {
                    <span class="validate-error-text">{{
                      CONSTS.VALIDATION_FAILED_AAA_UNAVAILABLE
                    }}</span>
                  }
                  @if (validationCode === "-1") {
                    <span class="validate-error-text">{{
                      CONSTS.VALIDATION_FAILED_SOURCE_INVALID
                    }}</span>
                  }
                  @if (
                    validationCode === "0" && !validatedLngNr && !validatedLatNr
                  ) {
                    <span class="validate-error-text">{{
                      CONSTS.VALIDATION_FAILED_NO_LATLONG
                    }}</span>
                  }
                  @if (
                    validationCode === "0" && validatedLngNr && validatedLatNr
                  ) {
                    <span class="validate-success-text">{{
                      CONSTS.VALIDATION_SUCCEEDED
                    }}</span>
                  }
                </ion-col>
              </div>
              <ion-col class="validate-button-col">
                <button
                  type="button"
                  class="validate-button"
                  (click)="validate()"
                  [class]="
                    pickupForm.dirty && pickupForm.valid
                      ? 'enabled'
                      : 'disabled'
                  "
                  [disabled]="!pickupForm.dirty || !pickupForm.valid"
                >
                  <span>{{ CONSTS.VALIDATE }}</span>
                </button>
              </ion-col>
            </ion-row>
          </div>
        }
        <!-- Save button -->
        <button
          class="save-button"
          type="submit"
          [class]="
            pickupForm.dirty && pickupForm.valid ? 'enabled' : 'disabled'
          "
          [disabled]="!pickupForm.dirty || !pickupForm.valid"
        >
          <img [src]="SRC.CHECK_WHITE" alt="save" />
          <span>{{ CONSTS.SAVE }}</span>
        </button>
      </div>
    </app-modal-frame>
  </form>
</div>
